import { createSelector } from '@ngrx/store'
import { CurrenciesState } from '@spartacus/core'
import { MbSiteContextState } from '../state'
import { getMbSiteContextState } from './site-context.selectors'

export const getCurrenciesState = createSelector(
  getMbSiteContextState,
  (state: MbSiteContextState) => state?.currencies
)
export const getCurrenciesEntities = createSelector(
  getCurrenciesState,
  (state: CurrenciesState) => state?.entities
)
export const getActiveCurrency = createSelector(
  getCurrenciesState,
  (state: CurrenciesState) => state?.activeCurrency
)
export const getAllCurrencies = createSelector(
  getCurrenciesEntities,
  entities => entities && Object.keys(entities).map(isocode => entities[isocode])
)
